import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountForgotPasswordCheckEmail implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountForgotPasswordCheckEmailContainer";
    }
    render(){
        // console.log("forgot password check email");
    }
}
